import React from 'react';

import { cf } from './c_20210427a_YSh/cf';
import { ce } from './c_20210427a_YSh/ce';
import { iv } from './c_20210427a_YSh/iv';
import { ic } from './c_20210427a_YSh/ic';
import { bf } from './c_20210427a_YSh/bf';
import { cp } from './c_20210427a_YSh/cp';
import { ip } from './c_20210427a_YSh/ip';

import cView from './c_20210427a_YSh/cView';

export default class iMngList extends cView {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
//    global.c = this;
  }

  $id_stss = {
    sdld_cm30sss1: {},
    sdld_cm30sss3: {},
    sdld_cm31sss: {},
    sb_chk: false,
  };

  $ilp_bfrLoads = () => [
  ];

  $ilp_loads = () => [
    global.c?._op_load1(),
    cp.op_loadCm31(),
  ];

_op_load1 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_cm30sss1',
  dd_elmDefss: {
    cm30: { // alias
      ctr: 'slc',
      elm: 'cm30',
      n_dms: 3,
      o_cnd: _dd_prtss => { // 全ての表示対象の部門
        let _cnd = bf.q(`
          [cm30b11k]="{}" AND
          IFNULL([cm30cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
        ));
//bf.l('52: {}'.f(_cnd, _dd_prtss))
        return _cnd;
      },
/*
      ld_sortss: [
        { fld: 'cm30cz10', dtn: 'desc', mode: 'str' },
        { fld: 'cm30cx10', dtn: 'asc', mode: 'nmb' },
      ],
*/
      dd_cldDefss: {
        cm40: { // alias
          ctr: 'slc',
          elm: 'cm40',
          n_dms: 3,
          o_cnd: _dd_prtss => {
            let _cnd = bf.q(`
              [cm40b11k]="{}" AND
              [cm40b21k]="{}" AND
              [cm40l11e]="mngSht" AND
              IFNULL([cm40cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_prtss.cm30.d_flds._KEY,
//              _dd_prtss.cm30._KEY,
            ));
//bf.l('75: {}'.f(_cnd, _dd_prtss))
            return _cnd;
          },
/*
          ld_sortss: [
            { fld: 'cm40cz10', dtn: 'desc', mode: 'str' },
            { fld: 'cm40cx10', dtn: 'asc', mode: 'nmb' },
          ],
*/
          dd_cldDefss: {
          },
        },
      },
    },
  },
});

_op_load3 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_cm30sss3',
  dd_elmDefss: { // 設定用
    cm30: { // alias
      ctr: 'slc',
      elm: 'cm30',
      n_dms: 3,
      o_cnd: _dd_prtss => { // 権限がある表示対象の部門
        let _cnd = bf.q(`
          [cm30b11k]="{}" AND
          [_KEY] IN (
            SELECT
              [cm31b21k]::NUMERIC::INTEGER
            FROM
              [t_cm31]
            WHERE
              [cm31b11k]="{}" AND
              [cm31b31k]="{}" AND
              IFNULL([cm31cz10],"10")<>"0"
          ) AND
          IFNULL([cm30cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgcd_pagePntKeys.cm10_key,
        ));
        return _cnd;
      },
/*
      ld_sortss: [
        { fld: 'cm30cz10', dtn: 'desc', mode: 'str' },
        { fld: 'cm30cx10', dtn: 'asc', mode: 'nmb' },
      ],
*/
      dd_cldDefss: {
        cm40: { // alias
          ctr: 'slc',
          elm: 'cm40',
          n_dms: 3,
          o_cnd: _dd_prtss => {
            let _cnd = bf.q(`
              [cm40b11k]="{}" AND
              [cm40b21k]="{}" AND
              [cm40l11e]="mngSht"
              AND IFNULL([cm40cz10],"10")<>"0"
            `.f(
              global.c?.state.sgcd_pagePntKeys.cm20_key,
              _dd_prtss.cm30.d_flds._KEY,
//              _dd_prtss.cm30._KEY,
            ));
            return _cnd;
          },
          ld_sortss: [
            { fld: 'cm40cz10', dtn: 'desc', mode: 'str' },
            { fld: 'cm40cx10', dtn: 'asc', mode: 'nmb' },
          ],
          dd_cldDefss: {
          },
        },
      },
    },
  },
});

  $ip_ins = () => new Promise( _o_end1 => {
  });

  $ilp_upds = () => [
    cf.myCB_call_tree({ // for delete cm40
      ctr: 'iud',
      state: 'sdld_cm30sss3',
      dd_elmDefss: {
        cm30: {
          od_insDats: null,
          dd_cldDefss: {
            cm40: {
              od_insDats: null,
            },
          }
        },
      },
    }),
  ];


  $cld_onChgss = cp.cld_onChgss;

  $ild_onChgss = () => [
  ];

  render() {
/*
          b_rhtVsb={(global.c?.state.sgc_pageMode == 'show' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? true : false}
          rhtIconName={'gear'}
          rhtPfx={'設定'}
          onRhtPrs={()=>{
            cf.myRN_set_pageMode('edit')
            .then(() => {
              global.c?._op_load3();
            });
          }}
 */
    return (
      <this.$onChg
        key={-1}
      >
        <ce.RootDtl
          key={-1}
          b_logo={false}
          b_sch={false}
          onSchEnt={null}
          b_rhtVsb={
            (global.c?.state.sgc_pageMode == 'show' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? 
              true 
            : (global.c?.state.sgc_pageMode == 'edit' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? 
              true 
            : false
          }
          rhtIconName={
            (global.c?.state.sgc_pageMode == 'show' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? 
              'gear'
            : (global.c?.state.sgc_pageMode == 'edit' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? 
              'check-square-o'
            : null
          }
          rhtPfx={
            (global.c?.state.sgc_pageMode == 'show' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? 
              '設定'
            : (global.c?.state.sgc_pageMode == 'edit' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? 
              '選択'
            : null
          }
          onRhtPrs={
            (global.c?.state.sgc_pageMode == 'show' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? 
              () => {
                cf.myRN_set_pageMode('edit')
                .then(() => {
                  global.c?._op_load3();
                });
              }
            : (global.c?.state.sgc_pageMode == 'edit' && bf.myCM_get_len(global.c?.state.sdld_cm31sss?.cm31) > 0) ? 
              () => {
//bf.l('219: hello.')
                global.c?.setState({
                  sb_chk: true,
                })
              }
            : null
          }
          d_hdrs={{
            pfx: iv._get_hdrPfx('チェックシート一覧'),
            d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgc_pageMode),
            d_subMenus: {
              b_vsb: (global.c?.state.sgc_pageMode == 'edit' && global.c?.state.sdld_cm30sss3 && bf.f(global.c?.state.sdld_cm30sss3?.cm30)) ? true : false,
              pfx: 'CSV',
              ld_iss: [
                ip.$dd_subMenuss['チェックシート一覧CSV出力'],
                ip.$dd_subMenuss['チェックシート項目CSV出力'],
                ip.$dd_subMenuss['チェックシート回答CSV出力'],
                ip.$dd_subMenuss['チェックシート事例CSV出力'],
                ip.$dd_subMenuss['チェックシート一覧CSV取込'],
                ip.$dd_subMenuss['チェックシート項目CSV取込'],
                ip.$dd_subMenuss['チェックシート回答CSV取込'],
                ip.$dd_subMenuss['チェックシート事例CSV取込'],
              ],
            }
          }}
          lo_hdrs={
            (global.c?.state.sb_chk) ? 
              [
                ce.c(ce.BtnIconPfx, {
                  key: -1,
                  iconName: 'remove',
                  pfx: 'キャンセル',
                  ccd: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                  onPrs: () => {
                    global.c?.setState({
                      sb_chk: false,
                      sdld_cm30sss3: bf.p(global.c?.state.sdld_cm30sss3, _next => {
                        _next.cm30.map( _d_cm30Dats => {
                          _d_cm30Dats.dld_cldDatsss.cm40.map( _d_cm40Dats => {
                            if (_d_cm40Dats.b_chk) _d_cm40Dats.b_chk = false;
                          })
                        })
                      })
                    });
                  },
                  stlCta: {
                    height: ic.gn_btnIconSize + ic.gn_fontSizeSml,
                  },
                }),
              ]
            : null
          }
          lo_ftrs={
            (global.c?.state.sb_chk) ? 
              [
                ce.c(ce.BtnIconPfx, {
                  key: -1,
                  iconName: 'trash',
                  pfx: '削除',
                  ccd: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
                  onPrs: () => {
                    let _n_cnt = global.c?.state.sdld_cm30sss3.cm30.reduce( (_prev, _d_cm30Dats) => {
                      let _n_cnt2 = _d_cm30Dats.dld_cldDatsss.cm40.reduce( (_prev2, _d_cm40Dats) => {
                        return (_d_cm40Dats.b_chk) ? (_prev2 + 1) : _prev2
                      }, 0)
                      return _prev + _n_cnt2
                    }, 0)
                    if (_n_cnt == 0) {
                      alert('項目を選択ください')
                    }
                    else {
                      global.c?.setState({
                        sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                          _next.cfm.b_showMdl = true;
                          _next.cfm.msg = '選択項目を削除してよろしいですか？';
                          _next.cfm.ld_btnss = [
                            {
                              pfx:'はい',
                              o_onPrs: async () => {
                                global.c?.setState({
                                  sdld_cm30sss3: bf.p(global.c?.state.sdld_cm30sss3, _next => {
                                    _next.cm30.map( _d_cm30Dats => {
                                      _d_cm30Dats.dld_cldDatsss.cm40.map( _d_cm40Dats => {
                                        if (_d_cm40Dats.b_chk) {
                                          _d_cm40Dats.b_dlt = true;
                                        };
                                      })
                                    })
                                  })
                                }, () => {
//bf.l('329: {}'.f(global.c?.state.sdld_cm30sss3));
                                  global.c?.upd();
                                });
                              },
                            },
                            {
                              pfx:'いいえ',
                            },
                          ];
                        }),
                      });
                    }
                  },
                }),
              ]
            : null
          }
          d_bdys={{
            ld_defss: [
              {
                type: 'InpTree3',
                b_vsb: (global.c?.state.sgc_pageMode == 'show') ? true : false, // 閲覧モード
                b_edt: false,
                state: 'sdld_cm30sss1',
                dd_elmDefss: {
                  cm30: {
                    b_hideOnNoCld: true,
                    b_newLine: false,
                    dd_fldDefss: {
                      cm30c310: {
                        type: 'Inp',
                        b_dltPrs: false,
                        stlCta: {
                          borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                          borderWidth: 0,
                          borderBottomWidth: ic.gn_bdrWNrw,
                          borderRadius: 0,
                        },
                      },
                    },
                    dd_cldDefss: {
                      cm40: {
                        b_newLine: false,
                        dd_fldDefss: {
                          cm40c310: {
                            type: 'Inp',
                            onFldPrs: _d_dats => {
                              global.c?.setState({
                                sgcd_pagePntKeys: bf.p( global.c?.state.sgcd_pagePntKeys, _next => {
                                  _next.cm30_key = _d_dats.d_flds.cm40b21k;
                                  _next.cm40_key = _d_dats.d_flds._KEY;
                                  _next.cm31c410 = '10'; // 一般利用者として表示
                                }),
                              }, () => {
                                let _d_pageInfs = {
                                  sgc_pageRole: global.c?.state.sgc_pageRole,
                                  sgc_pageName: 'iMngInp',
                                  sgc_pageMode: 'show',
                                  sgc_pageKey: _d_dats.d_flds._KEY,
                                  sgcn_tab: 4,
                                };
                                cf.myRN_move_fwd(_d_pageInfs);
                              })
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },

              {
                type: 'InpTree3',
                state: 'sdld_cm30sss3',
                b_vsb: (global.c?.state.sgc_pageMode == 'edit') ? true : false, // 設定モード
                b_edt: false,
                dd_elmDefss: {
                  cm30: {
                    b_newLine: false,
                    dd_fldDefss: {
                      cm30c310: {
                        type: 'Inp',
                        b_edt: false,
                        b_dltPrs: false,
//                        b_btnPrs: true,                  
                        b_btnPrs: (global.c?.state.sb_chk == false) ? true : false,
                        onBtnPrs: _d_flds => {
                          global.c?.setState({
                            sgcd_pagePntKeys: bf.p( global.c?.state.sgcd_pagePntKeys, _next => {
                              _next.cm30_key = _d_flds._KEY;
                              _next.cm31c410 = '20'; // 部門運営者として表示
                            }),
                          }, () => {
                            let _d_pageInfs = {
                              sgc_pageRole: global.c?.state.sgc_pageRole,
                              sgc_pageName: 'iMngDtl',
                              sgc_pageMode: 'new',
                              sgc_pageKey: '',
                            };
                            cf.myRN_move_fwd(_d_pageInfs);
                          })
                        },
                        stlCta: {
                          borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                          borderWidth: 0,
                          borderBottomWidth: ic.gn_bdrWNrw,
                          borderRadius: 0,
                        },
                      },
                    },
                    dd_cldDefss: {
                      cm40: {
//                        b_newLine: false,
                        b_row: true,
                        d_chks: {
//                          b_vsb: true,
                          b_vsb: (global.c?.state.sb_chk) ? true : false,
                        },
                        dd_fldDefss: {
                          cm40c310: {
                            type: 'Inp',
                            b_edt: false,
                            b_dltPrs: false,
/*
                            o_sfx: _d_dats => {
                              return (_d_dats.d_flds.cm40cz10 == '10') ? '表示する' : '表示しない';
                            },
*/
                            onFldPrs: _d_dats => {
                              if (global.c?.state.sb_chk == false) {
                                global.c?.setState({
                                  sgcd_pagePntKeys: bf.p( global.c?.state.sgcd_pagePntKeys, _next => {
                                    _next.cm30_key = _d_dats.d_flds.cm40b21k;
                                    _next.cm40_key = _d_dats.d_flds._KEY;
                                    _next.cm31c410 = '20'; // 部門運営者として表示
                                  }),
                                }, () => {
                                  let _d_pageInfs = {
                                    sgc_pageRole: global.c?.state.sgc_pageRole,
                                    sgc_pageName: 'iMngDtl',
                                    sgc_pageMode: 'show',
                                    sgc_pageKey: _d_dats.d_flds._KEY,
                                  };
                                  cf.myRN_move_fwd(_d_pageInfs);
                                })
                              };
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },

              {
                type: 'Msg',
                b_vsb: (global.c?.state.sgc_pageMode == 'edit' && global.c?.state.sdld_cm30sss3 && bf.f(global.c?.state.sdld_cm30sss3?.cm30) == false) ? true : false,
                pfx: '設定可能な部門がありません',
              }

            ],

          }}

        />
      </this.$onChg>
    );
  }

}
